
































































import { Component, Vue, Watch } from 'vue-property-decorator'
import eventModule from '@/store/event'
import dealModule from '@/store/deal'
import { DiscountType, TextFieldRules } from '@/utils/enums'
import QrcodeVue from 'qrcode.vue'
import authModule from '@/store/auth'

@Component({
  components: {
    QrcodeVue
  }
})
class DealRedeemDialog extends Vue {
  private code = ''
  private rules = TextFieldRules
  private isQRCode = false

  private get deal() {
    return dealModule.deal
  }

  private get isLoggedIn(): boolean {
    return authModule.user ? true : false
  }

  private get isInfo(): boolean {
    console.log(dealModule.deal.discount.type)
    return dealModule.deal.discount.type === DiscountType.INFO
  }

  private get isCoupon(): boolean {
    return dealModule.isCoupon
  }
  private get dialogTitle(): string {
    return dealModule.isCoupon ? 'Wertgutschein kaufen' : 'Gutschein einlösen'
  }

  private get instructionText(): string {
    if (dealModule.isCoupon) {
      return 'Dieser Gutschein muss von dir gekauft und beim Anbieter eingelöst werden. Im nächsten Schritt kannst du den Wert Deines Gutscheins auswählen und ihn kaufen.'
    }
    if (!dealModule.isLocal) {
      return 'Um diesen Gutschein einzulösen, nutze\nden folgenden Gutscheincode'
    } else {
      if (!this.code) {
        return 'Zum einlösen, bitte den Gutscheincode\nvom Anbieter eingeben lassen.'
      } else {
        return 'Zum einlösen, bitte den Gutscheincode\nvom Anbieter einscannen lassen.'
      }
    }
  }

  private get redeemBtnText(): string {
    return dealModule.deal.ctaTitle
      ? dealModule.deal.ctaTitle
      : dealModule.isCoupon
      ? 'Gutschein kaufen'
      : 'Einlösen'
  }

  private get codeValue() {
    if (!dealModule.isLocal) {
      return this.code || 'Kein Code notwendig'.toUpperCase()
    }
    return ''
  }

  private set codeValue(val: string) {
    this.code = val
  }

  private get actionText(): string {
    if (dealModule.isCoupon) {
      return 'ZUM WARENKORB'
    } else {
      return !dealModule.isLocal ? 'ZUM ONLINESHOP' : 'EINLÖSEN'
    }
  }

  private get isOut(): boolean {
    return this.deal.redemptionType.endsWith('_out')
  }

  private get isReadonly(): boolean {
    return !dealModule.isLocal && !this.code
  }

  private get isValidForm(): boolean {
    return !dealModule.isEcommerce && this.code.length === 0
  }

  @Watch('deal')
  private async resetCode(): Promise<void> {
    if (authModule.user) {
      await this.fetchCode()
    }
  }

  private async created(): Promise<void> {
    if (authModule.user) {
      await this.fetchCode()
    }
  }

  private async fetchCode(): Promise<void> {
    this.code = ''
    if (this.isOut) {
      this.code = await dealModule.fetchCode()

      if (typeof this.code === 'undefined') {
        eventModule.newError(
          'Alle Gutscheincodes sind leider aktuell vergriffen! Bitte versuche es bald erneut!'
        )
        document.dispatchEvent(new Event('close-redeem'))
        return
      }

      this.isQRCode =
        !dealModule.isCoupon && dealModule.isLocal && this.code.length > 0
          ? true
          : false
    }
  }

  private async redeemDeal(): Promise<void> {
    if (dealModule.isCoupon) {
      window.open(this.formatURL(this.deal.referralUrl), '_blank')
      document.dispatchEvent(new Event('close-redeem'))
      return
    }
    if (!dealModule.isLocal || dealModule.isInfo) {
      window.open(this.formatURL(this.deal.referralUrl), '_blank')
    } else {
      await dealModule.redeem(this.code)
    }
    document.dispatchEvent(new Event('close-redeem'))
  }

  private goToLogin(): void {
    this.$router.replace({ name: 'Login' })
  }

  private formatURL(url: string): string {
    if (url.startsWith('http')) {
      return url
    } else {
      return `https://${url}`
    }
  }
}

export default DealRedeemDialog
